import React from 'react';
import { Form } from 'react-bootstrap';
import './css/spqAnswer.scss';
const AnswerTypeRadio = ({ data, qNo, onChangeRadio }) => {
  return (
    <>
      <div className="w-100 spqAswerTypeRadio">
        <Form>
          {
            data?.options?.length > 0 &&
              data?.options?.map((_opt, index) => (
                <div className="spqAswerTypeRadioRow mb-4" key={index + 1}>
                  <Form.Check
                    type="radio"
                    name={`qNo${qNo}`}
                    checked={data.selectedIndex === _opt.value}
                    id={`radio${qNo}${_opt.value}`}
                    label={_opt.label}
                    onChange={() => {
                      onChangeRadio(_opt.value);
                    }}
                  />
                </div>
              ))
            // <div className="spqAswerTypeRadioRow">
            //   <Form.Check
            //     className="cmnRadioBtn d-inline"
            //     type="radio"
            //     label="Option 1"
            //     name="spqAnswerRadio"
            //   />
            // </div>
          }
        </Form>
      </div>
    </>
  );
};

export default AnswerTypeRadio;
